export const OPEN_EMAIL_CHANNEL_CAPTURE = 'SETTINGS/OPEN_EMAIL_CHANNEL_CAPTURE';
export const CLOSE_EMAIL_CHANNEL_CAPTURE = 'SETTINGS/CLOSE_EMAIL_CHANNEL_CAPTURE';
export const OPEN_WEB_PUSH_CHANNEL_CAPTURE = 'SETTINGS/OPEN_WEB_PUSH_CHANNEL_CAPTURE';
export const CLOSE_WEB_PUSH_CHANNEL_CAPTURE = 'SETTINGS/CLOSE_WEB_PUSH_CHANNEL_CAPTURE';
export const CREATE_WEB_PUSH_USER_ON_SERVER = 'SETTINGS/CREATE_WEB_PUSH_USER_ON_SERVER';



// WEBPACK FOOTER //
// ./app/NotificationsManager/settings/actionTypes.js